// extracted by mini-css-extract-plugin
export default {"auth":"AuthForm_auth__Vc3Rw","control":"AuthForm_control__Mtec2","actions":"AuthForm_actions__O4wHv","toggle":"AuthForm_toggle__d3jbw"};